"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    env: 'production',
    cookies: {
        skype: {
            name: 'SC',
            path: '/',
            maxAge: 3600 * 24 * 90,
            domain: '.skype.com',
        },
        csrf: {
            name: 'x-csrf-token',
        },
    },
    logging: {
        ariaTenant: '36f18b389f2543c0b54bf5c5555e3587-e50b4ede-9173-4805-ab3a-7c8564e50b52-6674',
    },
    silentLogin: {
        env: 'live',
        client_id: '371752',
        redirect_uri: 'https://join.skype.com',
    },
    urls: {
        ecs: 'https://a.config.skype.com',
        api: {
            profile: 'https://profile.skype.com/profile',
            huddle: 'https://join.skype.com/api',
            meetings: 'https://api.join.skype.com',
            invite: 'https://inviteconnector.skype.com',
            captcha: (lang, flowId, rand) => `https://client.hip.live.com/GetHIP/GetWLSPHIP0/WLSPHIP0?mkt=${lang}&fid=${flowId}&id=skypeguest&type=visual&rnd=${rand}`,
        },
        app: {
            faq: 'https://go.skype.com/faq.invites',
            login: (redirectUri, state) => `https://login.skype.com/login?client_id=578134&redirect_uri=${encodeURIComponent(redirectUri)}&state=${state}`,
            logout: (redirectUri, state) => `https://login.skype.com/logout?client_id=578134&redirect_uri=${encodeURIComponent(redirectUri)}&state=${state}`,
            s4lWeb: (params, webSubDomain) => {
                const url = `https://${!!webSubDomain ? `${webSubDomain}.` : ''}web.skype.com`;
                if (params.threadId) {
                    return `${url}/${params.threadId}`;
                }
                if (params.inviteId && params.skypeId) {
                    return `${url}/8:${params.skypeId}?inviteId=${params.inviteId}`;
                }
                return url;
            },
            botLogin: (botId, useBotLauncherQueryParam) => {
                const loginUri = `https://login.skype.com/login?client_id=708557&redirect_uri=https%3A%2F%2Fjoin.skype.com%2Fbot%2F${botId}`;
                if (useBotLauncherQueryParam) {
                    return loginUri + '?botsLauncher=true';
                }
                return loginUri;
            },
            download: 'https://go.skype.com/spaces.getskype',
            downloadAndroid: 'https://play.google.com/store/apps/details?id=com.skype.raider',
            downloadDesktop: 'https://go.skype.com/download-skype/',
            cookiePolicy: 'https://go.skype.com/privacy',
            skypeCom: 'https://www.skype.com',
        },
        launcher: {
            skypeUri: (action, threadId, sessionId, origin) => `skype:?${action}&threadId=${threadId}&session_id=${sessionId}&origin=${origin}`,
            intentUri: (action, threadId, sessionId, origin, fallbackUri) => `intent://?${action}&threadId=${threadId}&session_id=${sessionId}&origin=${origin}`
                + `#Intent;scheme=skype;package=com.skype.raider;S.browser_fallback_url=${encodeURIComponent(fallbackUri)};end;`,
            universalUri: (shortId) => `https://www.skype.com/meetnow/${shortId}`,
        },
        inviteLauncher: {
            skypeUri: (skypeId, sessionId, offSkypeInviteId, origin) => `skype:${skypeId}?chat&session_id=${sessionId}&utm_source=buddy&utm_content=${offSkypeInviteId}&origin=${origin}`,
            intentUri: (skypeId, sessionId, offSkypeInviteId, origin, fallbackUri) => `intent://${skypeId}?chat&session_id=${sessionId}&utm_source=buddy&utm_content=${offSkypeInviteId}&origin=${origin}`
                + `#Intent;scheme=skype;S.browser_fallback_url=${encodeURIComponent(fallbackUri)};end;`,
        },
        botLauncher: {
            skypeUri: (botId, sessionId, origin) => `skype:${botId}?chat&session_id=${sessionId}&origin=${origin}`,
            intentUri: (botId, sessionId, origin, fallbackUri) => `intent://${botId}?chat&session_id=${sessionId}&origin=${origin}` + `#Intent;scheme=skype;S.browser_fallback_url=${encodeURIComponent(fallbackUri)};end;`,
        },
        doLauncher: {
            skypeUri: (action, skypeId, sessionId, origin) => `skype:${skypeId}?${action}&session_id=${sessionId}&origin=${origin}`,
            intentUri: (action, skypeId, sessionId, origin, fallbackUri) => `intent://${skypeId}?${action}&session_id=${sessionId}&origin=${origin}`
                + `#Intent;scheme=skype;S.browser_fallback_url=${encodeURIComponent(fallbackUri)};end;`,
        },
    },
};
exports.default = config;
